import React from 'react';
import { useTranslation } from 'react-i18next';

import './MGPanels.css';

const Intro: React.FC = () => {

  const { t } = useTranslation();

  return (
    <div className='mg-intro'>
      <div className='mg-intro-left'>
        <div className='mg-intro-left-list'>
          <ul>
            <li>{t('properties/atacama:meetingsEvents.features.0' as any)}</li>
            <li>{t('properties/atacama:meetingsEvents.features.1' as any)}</li>
            <li>{t('properties/atacama:meetingsEvents.features.2' as any)}</li>
            <li>{t('properties/atacama:meetingsEvents.features.3' as any)}</li>
            <li>{t('properties/atacama:meetingsEvents.features.4' as any)}</li>
            <li>{t('properties/atacama:meetingsEvents.features.5' as any)}</li>
          </ul>
        </div>

        <div className='mg-intro-left-image'>
          <img src="/assets/images/meetings-events/c33b334690d591338bf28c1e9153c04d11f8dba5.png" alt="Small detail" />
        </div>
      </div>

      <div className='mg-intro-right'>
        <img
          src="/assets/images/meetings-events/Jaimie+Bojan(344).jpg"
          alt="Atacama landscape"
          className="meetings-diptych__image"
        />
      </div>
    </div>
  );
};

export default Intro;